export class UserData {
  id: number;
  name: string;
  email: string;
  email_verified_at: any;
  role_id: number;
  phone: string;
  created_at: string;
  updated_at: string;
}
